'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'
import { useHover } from '../HoverContext'
import { getActiveSection } from '../navigationUtils'
import { tracking } from '@/tracking'

interface MainNavLinksProps {
  magicMenuDropdown: ReactNode
  playingCardsMenuDropdown: ReactNode
  storesMenuDropdown: ReactNode
  saleMenuDropdown: ReactNode | null
  showSaleNavigation: boolean
}

export const MainNavLinks = ({
  magicMenuDropdown,
  playingCardsMenuDropdown,
  storesMenuDropdown,
  saleMenuDropdown,
  showSaleNavigation,
}: MainNavLinksProps) => {
  const pathname = usePathname()
  const { setIsHovering } = useHover()

  const activeSection = getActiveSection(pathname)
  const isMagicActive = activeSection === 'magic'
  const isPlayingCardsActive = activeSection === 'playing-cards'
  const isStoresActive = activeSection === 'stores'
  const isSaleActive = activeSection === 'sale'

  return (
    <div
      className="hidden h-full lg:flex items-center"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className="group h-full flex items-center">
        <Link
          href="/"
          prefetch={false}
          onClick={() =>
            tracking.track('Clicked top menu', { 'Top menu text': 'MAGIC' })
          }
          className={`hover:underline hover:text-vi-red group-hover:underline group-hover:text-vi-red underline-offset-8 px-4 flex items-center justify-center h-full uppercase font-sans font-normal text-base tracking-[0.05em] cursor-pointer transition-all duration-200 ${
            isMagicActive ? 'text-vi-red underline' : 'text-gray-700'
          }`}
        >
          MAGIC
        </Link>
        {magicMenuDropdown}
      </div>
      <div className="group h-full flex items-center justify-center">
        <Link
          href="/playing-cards/"
          prefetch={false}
          onClick={() =>
            tracking.track('Clicked top menu', {
              'Top menu text': 'PLAYING CARDS',
            })
          }
          className={`hover:underline hover:text-vi-red group-hover:underline group-hover:text-vi-red underline-offset-8 px-4 flex items-center justify-center h-full uppercase font-sans font-normal text-base tracking-[0.05em] cursor-pointer transition-all duration-200 ${
            isPlayingCardsActive ? 'text-vi-red underline' : 'text-gray-700'
          }`}
        >
          PLAYING CARDS
        </Link>
        {playingCardsMenuDropdown}
      </div>
      <div className="group h-full flex items-center justify-center">
        <Link
          href="/magic-stores"
          prefetch={false}
          onClick={() =>
            tracking.track('Clicked top menu', { 'Top menu text': 'STORES' })
          }
          className={`hover:underline hover:text-vi-red group-hover:underline group-hover:text-vi-red underline-offset-8 px-4 flex items-center justify-center h-full uppercase font-sans font-normal text-base tracking-[0.05em] cursor-pointer transition-all duration-200 ${
            isStoresActive ? 'text-vi-red underline' : 'text-gray-700'
          }`}
        >
          STORES
        </Link>
        {storesMenuDropdown}
      </div>
      {showSaleNavigation && (
        <div className="group h-full flex items-center justify-center">
          <Link
            href="/sale/all/"
            prefetch={false}
            onClick={() =>
              tracking.track('Clicked top menu', { 'Top menu text': 'SALE' })
            }
            className={`hover:underline hover:text-red-800 group-hover:underline group-hover:text-red-800 underline-offset-8 px-4 flex items-center justify-center h-full uppercase font-sans font-bold text-base tracking-[0.05em] cursor-pointer transition-all duration-200 text-vi-red ${
              isSaleActive ? 'underline' : ''
            }`}
          >
            SALE
          </Link>
          {saleMenuDropdown}
        </div>
      )}
    </div>
  )
}
